import { useEffect } from 'react';
import { useSnapshot } from 'valtio';

import ChevronLeftIcon from '@cartwhl/ui/icons/ChevronLeftIcon';
import PauseIcon from '@cartwhl/ui/icons/PauseIcon';
import PlayIcon from '@cartwhl/ui/icons/PlayIcon';
import Button from '@cartwhl/ui/input/Button';
import GoButton from '@cartwhl/ui/input/GoButton';

import { uiStore } from 'stores';
import { AnimationPlayerStoreInstance } from 'stores/animationPlayerStoreFactory';

export default function MainPlayerControls({
  animationPlayerStore,
}: {
  animationPlayerStore: AnimationPlayerStoreInstance;
}) {
  const { isPlaying, disabled } = useSnapshot(animationPlayerStore.state);
  const { promptFocus } = useSnapshot(uiStore.state);

  return (
    <div className="flex h-full items-center gap-2">
      <Button
        variant="tertiary"
        disabled={disabled}
        icon={<ChevronLeftIcon className="pointer-events-none" />}
        onClick={() => animationPlayerStore.frameJump(-1)}
      />
      <GoButton
        active={!promptFocus && !disabled}
        disabled={disabled}
        icon={
          isPlaying ? (
            <PauseIcon className="pointer-events-none" />
          ) : (
            <PlayIcon className="pointer-events-none" />
          )
        }
        onClick={() => animationPlayerStore.playOrPause()}
      />
      <Button
        variant="tertiary"
        disabled={disabled}
        icon={<ChevronRightIcon className="pointer-events-none" />}
        onClick={() => animationPlayerStore.frameJump(1)}
      />
    </div>
  );
}

// TODO: Different chevrons in the design have different sizes... Let's consolodate all icons in the future
const ChevronRightIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3208 10.0068C15.3208 10.1507 15.2931 10.2835 15.2378 10.4053C15.1825 10.527 15.0994 10.6432 14.9888 10.7539L8.52246 17.0791C8.33984 17.2673 8.11296 17.3613 7.8418 17.3613C7.66471 17.3613 7.50146 17.3171 7.35205 17.2285C7.20264 17.1455 7.08366 17.0293 6.99512 16.8799C6.91211 16.736 6.87061 16.5755 6.87061 16.3984C6.87061 16.1328 6.97021 15.8976 7.16943 15.6929L12.9966 10.0068L7.16943 4.3208C6.97021 4.11605 6.87061 3.88363 6.87061 3.62354C6.87061 3.44092 6.91211 3.27767 6.99512 3.13379C7.08366 2.98991 7.20264 2.87646 7.35205 2.79346C7.50146 2.70492 7.66471 2.66064 7.8418 2.66064C8.11296 2.66064 8.33984 2.75195 8.52246 2.93457L14.9888 9.25977C15.0994 9.37044 15.1825 9.48665 15.2378 9.6084C15.2931 9.73014 15.3208 9.86296 15.3208 10.0068Z"
        fill="currentColor"
      />
    </svg>
  );
};
